module.exports = __webpack_public_path__ + "static/media/topvideos.5b564511.jpg";